import z from "zod";

import { ErrorClassification } from "../../../sentry/classification";
import type { ErrorDetails } from "../domain";

const scheduledEventsErrorTypeValues = ["UNKNOWN", "JOB_HAD_FAILURES"] as const;
const scheduledEventsErrorTypeSchema = z.enum(scheduledEventsErrorTypeValues);
const ScheduledEventsErrorType = scheduledEventsErrorTypeSchema.enum;
type ScheduledEventsErrorType = z.infer<typeof scheduledEventsErrorTypeSchema>;

export type ScheduledEventsErrors =
  | { errorType: typeof ScheduledEventsErrorType.UNKNOWN; data: undefined }
  | {
      errorType: typeof ScheduledEventsErrorType.JOB_HAD_FAILURES;
      data: { failedEventIds: string[] };
    };

export const scheduledEventsErrorDetails: Record<ScheduledEventsErrorType, ErrorDetails> = {
  UNKNOWN: { classification: ErrorClassification.UNEXPECTED_ERROR, sentryDescription: "Unknown Error" },
  JOB_HAD_FAILURES: { classification: ErrorClassification.UNEXPECTED_ERROR, sentryDescription: "Job had failures" },
};
